<template>
  <div id="app" >
    <HeaderComp />
    <transition name="fade">
    <router-view/>
    </transition>
    <footer-comp  v-if="!isHomePage" />
    
  </div>
</template>

<script>

  import HeaderComp from '@/components/HeaderComp.vue'
  import FooterComp from '@/components/FooterComp.vue'


  export default {

    name:'App',
    components:{
      HeaderComp,
      FooterComp
    },
    data: function(){
      return {
        screen:window.innerWidth
      }
    },
    computed: {
      isHomePage: function(){
        return (this.$route.path === '/') ? true : false;
      } 
    }
  }
</script>


